module.exports = __webpack_public_path__ + "img/nineton.991e4fc1.png";